import React from 'react'
import {StackScreenProps} from '@react-navigation/stack'

import {AppEvents} from 'src/lib/Analytics/app_events'
import {ApplicationStepsTemplate} from 'src/products/general/ApplicationSteps/ApplicationStepsTemplate'
import {ApplyInFewStepsTemplate} from 'src/products/general/ApplyInFewSteps/ApplyInFewStepsTemplate'
import {getIsAppRevampFunctionalUpdatesEnabled} from 'src/lib/experimentation/appRevampFeatureFlag'
import {usePageViewedAnalytics} from 'src/lib/Analytics/usePageViewedAnalytics'
import {usePushPermissions} from 'src/lib/usePushPermissions'
import {SignupWorkflowStackParams, WorkflowPreReqFulfillScreenProps} from 'src/workflows/types'
import {isDeviceWeb} from 'src/lib/utils/platform'

type ApplicationStepsContainerProps = WorkflowPreReqFulfillScreenProps &
  StackScreenProps<SignupWorkflowStackParams, 'ApplicationSteps'> & {
    isAdvance: boolean
  }

const ApplicationStepsContainer: React.FC<ApplicationStepsContainerProps> = (
  props,
): JSX.Element => {
  const {navigation, onPreReqFulfilled, isAdvance} = props
  const [hasPushPermissions] = usePushPermissions()
  const isAppRevampFunctionalUpdatesFFEnabled = getIsAppRevampFunctionalUpdatesEnabled()

  usePageViewedAnalytics({
    eventName: AppEvents.Name.application_steps_screen_viewed,
    eventCategory: AppEvents.Category.Onboarding,
  })

  navigation.setOptions(
    isAppRevampFunctionalUpdatesFFEnabled
      ? {
          headerShown: true,
          headerTintColor: 'white',
        }
      : {
          headerShown: false,
        },
  )

  const handleOnContinue = async (): Promise<void> => {
    if (isAppRevampFunctionalUpdatesFFEnabled) {
      await onPreReqFulfilled()
      return
    } else {
      // Web doesn't have push notifications so we skip it.
      if (!isDeviceWeb() && !hasPushPermissions) {
        navigation.navigate('NotificationsPermissions')
        return
      } else {
        await onPreReqFulfilled()
        return
      }
    }
  }

  if (isAppRevampFunctionalUpdatesFFEnabled && !isAdvance) {
    return <ApplicationStepsTemplate onContinue={handleOnContinue} />
  }

  return <ApplyInFewStepsTemplate onContinue={handleOnContinue} />
}

export {ApplicationStepsContainer}
